// api.ts
import axios from "axios";

let onUnauthorized: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: () => void) => {
    onUnauthorized = handler;
};


const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL_CONEKTAPP,
    headers: {
        "Content-Type": "application/json",
    },
});

const URL_COTIZADOR_NBS = import.meta.env.VITE_API_URL_COTIZADORNBS;

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Cotizador NBS: la API no valida el token; el usuario de la sesión va en encabezados (quién hace cada
    // cambio para auditoría e historial, y su país). Solo a ese API, no al core.
    if (URL_COTIZADOR_NBS && (config.url ?? '').startsWith(URL_COTIZADOR_NBS)) {
        try {
            const usuario = JSON.parse(localStorage.getItem("usuario") ?? "null");
            if (usuario?.Id) {
                config.headers["X-Usuario-Id"] = String(usuario.Id);
                // Codificado: los encabezados no admiten tildes ni ñ (el back lo decodifica).
                config.headers["X-Usuario-Nombre"] = encodeURIComponent(usuario.NombreCompleto || usuario.Email || "");
                if (usuario.PaisId) config.headers["X-Pais-Id"] = String(usuario.PaisId);
            }
        } catch {
            // Usuario guardado dañado: la petición sigue sin encabezados y el back lo trata como sin sesión.
        }
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && onUnauthorized) {
            onUnauthorized();
        }

        // Extraer el mensaje del backend si viene en el formato ApiResponse
        const data = error.response?.data;
        if (data?.Messages && Array.isArray(data.Messages) && data.Messages.length > 0) {
            error.mensajeBackend = data.Messages.join(' ');
        } else if (typeof data === 'string' && data.length > 0) {
            error.mensajeBackend = data;
        }

        return Promise.reject(error);
    }
);

// Cliente Axios dedicado para Devsmart-AI API
export const devsmartApi = axios.create({
    baseURL: import.meta.env.VITE_API_URL_DEVSMART_AI || import.meta.env.VITE_API_URL_CONEKTAPP,
    headers: {
        "Content-Type": "application/json",
    },
});

devsmartApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

